module.exports = __webpack_public_path__ + "img/buddy_eyes-05.2ee710b6.svg";